import { useCallback, useContext, useState, useEffect } from "react"; //evita que se vuelva a ejecutar una funcion
import UserContext from "context/UserContext";
//Firebase
import "firebase/auth";
import { useFirebaseApp, useUser as useUserFirebase } from "reactfire";
import Firebase from "firebase/app";
import { db } from "../firebase";

export default function useUser() {
  const firebase = useFirebaseApp();
  const user = useUserFirebase();
  const [profile, setProfile] = useState();
  const [state, setState] = useState({
    loading: false,
    error: false,
    loadingUser: true,
  });
  const [error, setError] = useState({ status: false, msg: "" });
  const [success, setSuccess] = useState({ status: false, msg: "" });
  const [errorMSG, setErrorMSG] = useState("");

  useEffect(() => {
    if (user.data) {
      setState({ loading: false, error: false, loadingUser: false });
      getProfile(user.data.uid);
    } else {
      setState({ loading: false, error: false, loadingUser: true });
      setTimeout(() => {
        setState({ loading: false, error: false, loadingUser: false });
      }, 500);
    }
  }, [user.data]);

  const register = async (email, password) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((e) => {
        setSuccess({ status: true, msg: "Registration completed!" });
        setTimeout(() => {
          setSuccess({ status: false, msg: "" });
          // history.push('/home');
        }, 1000);
      })
      .catch((e) => {
        setError({ status: true, msg: e.message });
        setTimeout(() => {
          setError({ status: false, msg: "" });
        }, 1000);
      });
  };

  const login_google = () => {
    const googleAuthProvider = new Firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(googleAuthProvider)
      .then((res) => {
        if (res.additionalUserInfo.isNewUser) {
          createProfile(res.user);
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const logout = () => {
    firebase.auth().signOut();
    setState({ loading: false, error: false, loadingUser: false });
    setProfile(null);
    window.location.reload();
  };

  const createProfile = useCallback((user) => {
    db.collection("profiles")
      .doc(user.uid)
      .set({ uid: user.uid, admin: false, email: user.email })
      .then(() => {
        db.collection("profiles")
          .doc(user.uid)
          .get()
          .then((snapshot) => {
            setProfile(snapshot.data());
          });
      });
  });

  const getProfile = useCallback((uid) => {
    db.collection("profiles")
      .doc(uid)
      .get()
      .then((snapshot) => {
        setProfile(snapshot.data());
      });
  });

  const refreshUserProfile = useCallback(() => {
    if (user && user.data) {
      db.collection("profiles")
        .doc(user.data.uid)
        .get()
        .then((snapshot) => {
          setProfile(snapshot.data());
        });
    } else {
      console.log("No se puede refrescar el perfil porque no hay usuario.");
    }
  });

  return {
    register,
    login_google,
    logout,
    isLogginLoading: state.loading,
    hasLoginError: state.error,
    errors: errorMSG,
    loadingUser: state.loadingUser,
    profile: profile,
    error: error,
    success: success,
    refreshUserProfile,
  };
}
